let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("97af4")).then(() => parcelRequire('Qdom1'));